import { Box } from "@chakra-ui/react";
import MediaEmbedV2 from "@components/Embeds/MediaEmbedV2";
import MidContainer from '@Layout/MidContainer';
import { render } from 'datocms-structured-text-to-html-string';
import ContentArea from '@components/Layout/ContentArea';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

let MSRInPersonYoutubeEmbed = ({ sectionContent, section }) => {

    return <Box pos={'relative'} height={'100%'}> <Box
        pos={'absolute'}
        zIndex={0}
        top={'0'}
        bgImage={{
            base: 'url(https://www.datocms-assets.com/46272/1747041785-msr_invitiation_bg_img_mobile.png)',
            md: `url(https://www.datocms-assets.com/46272/1747031632-msr_invitiation_bg_img_desktop.png)`
        }}
        backgroundSize={'cover'}
        mixBlendMode={'overlay'}
        aspectRatio={{ base: 0.56, md: 1.5 }}
        backgroundPosition={{
            base: '0px 70%',
            md: '0px 0rem',
            lg: '0px -18rem',
            '2xl': '0px -33rem',
        }}
        width={'100%'}
        height={'100%'}
        backgroundRepeat="no-repeat"
    />
        <Box
            ml={{ base: '0px', md: '7rem', lg: '7rem', xl: '-3rem', '2xl': '-3rem' }}
            mt={{ base: '-2rem', lg: '-1rem', md: '-6rem', lg: '-6rem', xl: '-1rem', '2xl': '-2rem' }}>
            <MediaEmbedV2 sectionContent={sectionContent} sectionId={section?.sectionId}
                width={{ base: '100%', md: '500px', lg: '500px', xl: '660px', '2xl': '660px' }} pageName={'msr-in-person'} />
        </Box>
        <Box zIndex={1} display={'flex'} justifyContent={'center'}
            mt={{ base: '0px', md: '-60px', lg: '-80px', xl: '0px', '2xl': '0px', }}
            px={{ base: '1rem', md: '0px', lg: '0px', }}
            pb={{ base: '30px', md: '20px', lg: '20px', xl: '50px', '2xl': '65px' }}
        >
            <StructuredTextParser
                sectionContent={section.sectionContent?.[2]}
                str={render(section.sectionContent?.[2]?.body)}
                color={'#fff'}
                w={{ base: '288px', md: '680px' }}
                maxW={'100%'}
                lineHeight={"180%"}
                textAlign={'center'}
                fontSize={'16px'}
                fontFamily={'FedraSansStd-book'}
            />
        </Box>
    </Box>;
}

export default MSRInPersonYoutubeEmbed;